export const mockData = {
  event: {
    name: 'REFUEL WEEKEND 27',
    date: '2.–4. april',
    tagline: 'Bli med på ei spennande helg i Øygarden – ein plass der du kan lære og oppleve tro, fellesskap, lovsang, konsert og møte nye folk.',
    location: 'Rong, Øygarden',
    audience: 'Klasse: 7. trinn og eldre ungdom',
  },
  navLinks: [
    { label: 'Om helga', href: '#om' },
    { label: 'Program', href: '#program' },
    { label: 'Påmelding', href: '#pamelding' },
    { label: 'Steder', href: '#steder' },
    { label: 'Talarar', href: '#talere' },
    { label: 'Partnarar', href: '#partnere' },
    { label: 'Aktivitetar', href: '/aktiviteter' },
    { label: 'Videoar', href: '/videoar' },
    { label: 'Galleri', href: '/galleri' },
  ],
  program: [
    {
      day: 'FREDAG',
      date: '2. APRIL',
      items: [
        { time: '19:00', title: 'Refuel night' },
        { time: '21:30', title: '???' },
      ],
    },
    {
      day: 'LØRDAG',
      date: '3. APRIL',
      items: [
        { time: '11:00', title: 'Kickoff' },
        { time: '12:00', title: 'Aktivitetar' },
        { time: '15:00', title: 'Middag' },
        { time: '16:15', title: 'Seminar' },
        { time: '18:30', title: 'Refuel night' },
        { time: '20:30', title: 'Best i vest' },
        { time: '22:00', title: 'Lovsongskveld' },
      ],
    },
    {
      day: 'SØNDAG',
      date: '4. APRIL',
      items: [
        { time: '11:00', title: 'Gudsteneste' },
        { time: '12:30', title: 'Kyrkjegrill' },
      ],
    },
  ],
  programPdf: '/Program_Refuel_Weekend_27.pdf',
  tripadvisor: 'https://no.tripadvisor.com/Attraction_Review-g3459177-d34713288-Reviews-Refuel_Weekend-Rong_Oygarden_Municipality_Hordaland_Western_Norway.html',
  signupForm: 'https://forms.gle/Nx3dv36noHZijdCAA',
  eventStart: '2027-04-02T18:00:00+02:00',
  activities: [
    { slug: 'fotball', short: 'Fotballøkt på bana på Rong', title: 'Fotball', description: 'Bli med på spennande fotballkampar og økter på bana på Rong. Perfekt for deg som elskar ballspel!', image: 'https://static.wixstatic.com/media/fa85c1_6be3dd723f1142d392c1b4ad30136293~mv2.jpg/v1/fill/w_1200,h_670,al_c,q_85,enc_auto/ai-generated-IMAGE.jpg' },
    { slug: 'paintball', short: 'Paintball', title: 'Paintball', description: 'Adrenalin og strategi i skjønn foreining. Utfordre venene dine til ein actionfylt runde paintball.', image: 'https://static.wixstatic.com/media/fa85c1_104c9193c00d4fa9a8f2c8613b57293d~mv2.jpg/v1/fill/w_1200,h_670,al_c,q_85,enc_auto/ai-generated-IMAGE.jpg' },
    { slug: 'volleyball', short: 'Volleyball i gymsal', title: 'Volleyball', description: 'Volleyball i gymsalen med god stemning og lagspel. Passar for alle nivå!', image: 'https://static.wixstatic.com/media/fa85c1_ae801a983a934a0c959b90dd91ea4973~mv2.jpg/v1/fill/w_1200,h_670,al_c,q_85,enc_auto/ai-generated-IMAGE.jpg' },
    { slug: 'krik', short: 'KRIK-økt i gymsal', title: 'KRIK-økt', description: 'Variert idrett og fellesskap i gymsalen. Ei økt prega av idrettsglede og verdiar.', image: 'https://static.wixstatic.com/media/fa85c1_d56f25116fee4cf597c8ec1fc603db83~mv2.jpg/v1/fill/w_1200,h_670,al_c,q_85,enc_auto/ai-generated-IMAGE.jpg' },
    { slug: 'president', short: 'Presidentturnering og spill', title: 'Presidentturnering & Spel', description: 'Turneringar i President og andre morosame spel. Finn din indre taktikar og vinn heder!', image: 'https://static.wixstatic.com/media/fa85c1_fac227d36e3a4af195166f1d09849582~mv2.jpg/v1/fill/w_1200,h_670,al_c,q_85,enc_auto/ai-generated-IMAGE.jpg' },
    { slug: 'bading', short: 'Bading i basseng', title: 'Bading i basseng', description: 'Forfriskande dukkertar i bassenget. Hugs badetøy og handkle!', image: 'https://static.wixstatic.com/media/fa85c1_8307e48884164d2c9bd8f2d883b8906d~mv2.jpg/v1/fill/w_1200,h_670,al_c,q_85,enc_auto/ai-generated-IMAGE.jpg' },
    { slug: 'buldring', short: 'Buldring', title: 'Buldring', description: 'Klatring utan tau i klatreveggen. Test styrke og balanse i trygge omgivnader.', image: null },
    { slug: 'gaming', short: 'Rocket League og FIFA', title: 'Rocket League & FIFA', description: 'Vis fram gamingferdigheitene dine! Sosiale og spennande rundar med dei mest populære spela.', image: null },
  ],
  pricing: {
    festivalPass: '200 kr',
    overnight: '50 kr',
    concertOnly: '200 kr',
    note: 'Betalinga for å delta på Refuel Weekend 2027 (heile helga) blir gjort ved ankomst i Hjeltefjorden Arena.',
  },
  speakers: [
    {
      id: 'thor-haavik',
      name: 'Thor Haavik',
      role: 'Talar',
      image: '/img/thor-haavik.webp',
      photoCredit: 'Espen Solli / TV 2',
      bio: [
        'Thor Haavik (f. 1994) er presten som vart heile Noregs favoritt då han dukka opp på Farmen og dobla folketalet i dåpsbassenget.',
        'Sidan den gong har han takla alt frå militær disiplin i Kompani Lauritzen til taktisk spionasje i Forræder. Til vanleg er han kapellan i Bergen, men du finn han like ofte på scener og skjermar der han pratar om tru, tvil og livets store spørsmål — alltid med rå energi, smil om munnen og null kleine prestevibbar.',
      ],
      socials: [
        { type: 'instagram', href: 'https://www.instagram.com/thorhaavik/' },
        { type: 'facebook', href: 'https://www.facebook.com/thorhaavik' },
      ],
    },
    {
      id: 'eivind-galdal',
      name: 'Eivind Galdal',
      role: 'Seminarhaldar',
      image: '/img/eivind-galdal.webp',
      bio: [
        'Eivind Galdal er ein driftig og raus mann som bur i Bergen og er pastor i Salt Bergenskirken. Her leier han studentarbeidet, og han har tidlegare vore ungdomsleiar i Skien.',
        'Laurdag kl. 16:15 held han seminar på Refuel Weekend – ikkje gå glipp av det!',
      ],
      socials: [
        { type: 'instagram', href: 'https://www.instagram.com/eivindgaldal/' },
      ],
    },
    {
      id: 'konsertartist',
      name: 'Kommer snart',
      role: 'Konsertartist',
      comingSoon: true,
    },
  ],
  hosts: [
    { id: 'moteleiar-1', name: 'Kommer snart', role: 'Møteleiar', comingSoon: true },
    { id: 'moteleiar-2', name: 'Kommer snart', role: 'Møteleiar', comingSoon: true },
  ],
  community: [
    { id: 'skjergardsheimen', name: 'Skjergardsheimen', tag: 'Leirstad i Øygarden', logo: '/img/naermiljo/skjergardsheimen.png', logoBg: true, href: 'https://skjergardsheimen.no/', description: 'Skjergardsheimen leirskule og leirstad er eit alkoholfritt alternativ for kurs, konferansar og ferie. Staden ligg idyllisk til ved Nautnes i Øygarden, om lag 60 km frå Bergen sentrum, med 22 rom, peisstove, spelerom, fotballbane og båtar og kanoar til utleige.' },
    { id: 'inri', name: 'INRI-Kyrkja', tag: 'Kyrkje på Rong', logo: '/img/naermiljo/inri.jpg', href: 'https://www.facebook.com/inrikyrkja/?locale=nb_NO', description: 'INRI-Kyrkja held til på Rong Senter i Øygarden. Ei levande kyrkje med gudstenester, lovsong og fellesskap for alle generasjonar – og heimebane for mange av oss bak Refuel.' },
    { id: 'refuel', name: 'Refuel', tag: 'Ungdomskveld annankvar fredag', logo: '/logo-wide.png', href: 'https://www.facebook.com/refueloygarden/?locale=nb_NO', description: 'Refuel er ungdomsarbeidet i Øygarden – med ungdomskveld annankvar fredag. Lovsong, tale, kafé og god stemning. Refuel Weekend er den store helga vår, men du er velkomen heile året!' },
    { id: 'krik', name: 'KRIK Øygarden', tag: 'Idrett og tru', logo: '/img/naermiljo/krik.png', href: 'https://www.facebook.com/groups/1698846647026429/', description: 'KRIK Øygarden er det lokale KRIK-laget – Kristen Idrettskontakt. Variert idrett, fellesskap og tru i gymsalen. KRIK har over 300 lokallag i Noreg og arrangerer idrettsleirar for barn og unge.' },
  ],
  promoPoster: '/img/galleri/refuel-02.webp',
  venues: [
    {
      name: 'Øygarden Ungdomsskule',
      description: 'Du kan sove på Øygarden Ungdomsskule dersom du bur langt vekk og ønskjer overnatting på skule. Skulen ligg like ved arenaen. Det blir servert frokost for dei som sov på skule.',
      link: 'https://www.oygarden.kommune.no/oygardenungdomsskule',
      image: 'https://customer-assets-jai6qajn.emergentagent.net/job_weekend-refuel/artifacts/mj0h2ia3_0c2639ec-a003-4f17-8c0e-fe0bbedafb99.webp',
    },
    {
      name: 'Hjeltefjorden Arena',
      description: 'Sjølve arrangementet finn stad i Hjeltefjorden Arena. Her held vi alt av aktivitetar, seminar, lovsang, underhaldning, tale og konsert.',
      link: 'https://oygardenil.no/treningsarenaer/hjeltefjorden-arena',
      image: 'https://customer-assets-jai6qajn.emergentagent.net/job_weekend-refuel/artifacts/aazlb0f5_0305ba69e6af_False_Stor_dc0b5c72-34dc-4234-92f4-9fe4a5010f21.webp',
    },
  ],
  heroImage: 'https://customer-assets-jai6qajn.emergentagent.net/job_weekend-refuel/artifacts/u6rrnkvu_Hjeltefjorden-arena_foto_Foto_Sindre-Ellingsen_9-1024x906.webp',
  logoImage: 'https://customer-assets-jai6qajn.emergentagent.net/job_weekend-refuel/artifacts/c7otbree_ChatGPT%20Image%202_%20sep_%202026%2C%2009_07_31.webp',
  refuelLogo: '/logo.png',
  refuelLogoWide: '/logo-wide.png',
  gallery: [
    { src: '/img/galleri/refuel-04.webp', alt: 'Konkurranse på scena under Refuel Weekend' },
    { src: '/img/galleri/refuel-02.webp', alt: 'Lovsong i Hjeltefjorden Arena' },
    { src: '/img/galleri/refuel-03.webp', alt: 'Paintball på Refuel Weekend' },
    { src: '/img/galleri/refuel-01.webp', alt: 'Lovsongskveld i Hjeltefjorden Arena' },
    { src: '/img/galleri/refuel-05.webp', alt: 'Thor Haavik talar på Refuel night', portrait: true },
    { src: '/img/galleri/refuel-06.webp', alt: 'Bingo og latter på Refuel Weekend' },
    { src: '/img/galleri/refuel-07.webp', alt: 'Lovsongsbandet i grønt lys' },
  ],
  promoVideo: '/video/promo.mp4',
  ctaImage: 'https://customer-assets-jai6qajn.emergentagent.net/job_weekend-refuel/artifacts/mj0h2ia3_0c2639ec-a003-4f17-8c0e-fe0bbedafb99.webp',
  socials: [
    { name: 'Instagram', href: 'https://www.instagram.com/refuelweekend/' },
    { name: 'Facebook', href: 'https://www.facebook.com/refueloygarden' },
    { name: 'TikTok', href: 'https://www.tiktok.com/@refuel.oygarden' },
    { name: 'Mail', href: 'mailto:info@refuel.rest' },
  ],
  sponsors: [
    { code: '01', name: 'KNT-SYS' },
    { code: '02', name: 'BLT-INV' },
    { code: '03', name: 'PK-PRF' },
    { code: '04', name: 'CRT-V2' },
  ],
  worshipSongs: [
    { title: 'Se, no kjem han', artist: 'Hillsong' },
    { title: 'Great Are You Lord', artist: 'All Sons & Daughters' },
    { title: 'Build My Life', artist: 'Pat Barrett' },
    { title: 'Goodness of God', artist: 'Bethel Music' },
    { title: 'Way Maker', artist: 'Sinach' },
    { title: 'King of Kings', artist: 'Hillsong Worship' },
  ],
};
